import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { defaultBorder, errorBorder } from 'shared/constants'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

interface SelectedFrom {
  name?: string
  code?: string
}

interface Props {
  from?: SelectedFrom
  to?: SelectedFrom
  onClick?: (name: string) => void
  onSwitch?: () => void
  type?: 'white' | 'grey' | 'lightGrey'
  padding?: number[]
  error?: boolean
}

export const DepArrCountryBlock: FC<Props> = ({
  from,
  to,
  onClick,
  onSwitch,
  type = 'grey',
  padding = [0, 20],
  error,
}) => {
  const { t } = useTranslation()

  return (
    <Paper
      type={type}
      radius={16}
      padding={padding}
      border={error ? errorBorder : defaultBorder}
    >
      <div className={s.container}>
        <div className={s.wrapper}>
          <div
            className={s.item}
            onClick={() => onClick?.('from')}
          >
            {from?.name ? (
              <div className={s.box}>
                <span className={clsx(s.label, 'medium-12')}> {t('from')}</span>
                <span className={s.selected}>
                  {from?.name}{' '}
                  {from?.code && <span className={s.code}>({from?.code})</span>}
                </span>
              </div>
            ) : (
              t('from')
            )}
          </div>
          <div
            className={s.item}
            onClick={() => onClick?.('to')}
          >
            {to?.name ? (
              <div className={s.box}>
                <span className={clsx(s.label, 'medium-12')}> {t('to')}</span>
                <span className={s.selected}>
                  {to?.name}{' '}
                  {to?.code && <span className={s.code}>({to?.code})</span>}
                </span>
              </div>
            ) : (
              t('to')
            )}
          </div>
        </div>

        {onSwitch && (
          <button
            className={clsx(s.button, type === 'white' && s.whiteButton)}
            onClick={onSwitch}
          >
            <AppIcon
              id={AllIcons.ARROWS_BOLD}
              height={32}
              width={32}
              className={s.icon}
            />
          </button>
        )}
      </div>
    </Paper>
  )
}
